import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Checkbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
  checkbox: {
    width: 22,
    height: 18,
    '&$checkboxChecked': {
      color: '#007bff',
    },
  },
  checkboxChecked: {},
})

const BlueCheckbox = React.forwardRef(({
  classes, className, onChange, checked
}, ref) => (
  <Checkbox
    ref={ref}
    size="medium"
    value="checked"
    checked={checked}
    onClick={onChange}
    classes={{
      root: classNames(classes.checkbox, className),
      checked: classes.checkboxChecked,
    }}
  />
))

BlueCheckbox.propTypes = {
  checked: PropTypes.any,
  onChange: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(BlueCheckbox)



// WEBPACK FOOTER //
// ./src/components/atoms/BlueCheckbox.js